import { connect } from 'react-redux'
import { actions as campaignActions } from '~publish/legacy/campaign'
import { campaignsPage, goTo } from '~publish/legacy/routes'

import { actions } from './reducer'
import type { AppDispatch, RootState } from '../store'

import CampaignForm, { type CampaignFormProps } from './components/CampaignForm'

interface OwnProps {
  editMode?: boolean
}

type StateProps = Pick<
  CampaignFormProps,
  'campaign' | 'isLoading' | 'editMode' | 'campaignId'
>

type DispatchProps = Pick<
  CampaignFormProps,
  'onCancelClick' | 'onCreateOrUpdateCampaignClick' | 'fetchCampaign'
>

const mapStateToProps = (state: RootState, ownProps: OwnProps): StateProps => ({
  campaign: state.campaignForm.campaign,
  isLoading: state.campaignForm.isLoading,
  editMode: ownProps.editMode ?? false,
  campaignId: state?.campaignForm?.campaignId,
})

const mapDispatchToProps = (dispatch: AppDispatch): DispatchProps => ({
  onCancelClick: (fromPath?: string): void => {
    if (fromPath) {
      // TO DO: update use of location change in Redux
      // https://linear.app/buffer/issue/CHAN-5410/redux-navigation-audit-document-use-of-push-in-middleware-and-location
      dispatch(goTo(fromPath))
    } else {
      // TO DO: update use of location change in Redux
      // https://linear.app/buffer/issue/CHAN-5410/redux-navigation-audit-document-use-of-push-in-middleware-and-location
      dispatch(campaignsPage.goTo())
    }
  },
  onCreateOrUpdateCampaignClick: ({
    campaignId,
    colorSelected,
    campaignName,
    orgId,
    editMode,
  }): void => {
    if (editMode) {
      dispatch(
        actions.handleEditCampaignClick({
          id: campaignId,
          name: campaignName,
          color: colorSelected,
          orgId,
        }),
      )
    } else {
      dispatch(
        actions.handleCreateCampaignClick({
          name: campaignName,
          color: colorSelected,
        }),
      )
    }
  },
  fetchCampaign: ({ campaignId }: { campaignId: string }): void => {
    dispatch(
      campaignActions.fetchCampaign({
        campaignId,
        past: false,
        sortDirection: 'desc',
        sortField: 'createdAt',
      }),
    )
  },
})

const connector = connect(mapStateToProps, mapDispatchToProps)
export default connector(CampaignForm)

export { default as reducer, actions, actionTypes } from './reducer'
export { default as middleware } from './middleware'
